export const prepareRegisterPayload = (formData: any, guestCategories: any[]) => {
    // Extract category objects with product_id
    const categories = guestCategories
        ? guestCategories.map(({ product_id, category_name }) => ({ product_id, category_name }))
        : [];

    return {
        ...formData,
        categories
    };
};
